import gql from 'graphql-tag';

export const CREATE_MERIT_ASSESSMENTS = gql`
  mutation ($input: CreateMeritAssessmentInput!) {
    createMeritAssessment(input: $input) {
      meritReferenceId
      meritType
      researchLevel
    }
  }
`;

export const GET_MERIT_ASSESSMENTS = gql`
  query ($filter: AssessmentFilter!) {
    meritAssessment(filter: $filter) {
      meritReferenceId
      meritType
      researchLevel
    }
  }
`;
